export default "__VITE_ASSET__BLQv2$6F__"